"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = void 0;
var react_1 = __importStar(require("react"));
require("../../../index.css");
var Toggle = /** @class */ (function (_super) {
    __extends(Toggle, _super);
    function Toggle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnClick = function (e) {
            if (_this.props.onClick) {
                _this.props.onClick(e);
            }
        };
        _this.handleTranslate = function () {
            var selectedTranslate = "translate-x-5";
            var unselectedTranslate = "translate-x-0";
            var defaultTranslate = "pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200 ";
            if (_this.props.value) {
                defaultTranslate += selectedTranslate;
            }
            else {
                defaultTranslate += unselectedTranslate;
            }
            return defaultTranslate;
        };
        _this.handleClassName = function () {
            var selectedColor = "bg-primary-600";
            var unselectColor = "bg-gray-200";
            var defaultClassName = "relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 ";
            if (_this.props.value) {
                defaultClassName += " ".concat(selectedColor);
            }
            else {
                defaultClassName += " ".concat(unselectColor);
            }
            return defaultClassName;
        };
        return _this;
    }
    Toggle.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "flex items-center ".concat(this.props.className) },
            this.props.direction === "left" && (react_1.default.createElement("span", { className: "mr-3" },
                react_1.default.createElement("span", { className: "text-sm font-medium text-gray-900" }, this.props.text))),
            react_1.default.createElement("button", { type: "button", className: this.handleClassName(), role: "switch", "aria-checked": "false", value: this.props.value.toString(), onClick: this.handleOnClick },
                react_1.default.createElement("span", { "aria-hidden": "true", className: this.handleTranslate() })),
            this.props.direction === "right" && (react_1.default.createElement("span", { className: "ml-3" },
                react_1.default.createElement("span", { className: "text-sm font-medium text-gray-900" }, this.props.text)))));
    };
    return Toggle;
}(react_1.Component));
exports.Toggle = Toggle;
//# sourceMappingURL=index.js.map